import type { ComponentProps } from 'react'

export const FlashIcon = (props: ComponentProps<'svg'>) => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color="currentColor"
            {...props}
        >
            <path
                d="M13 10V3L5 14H11V21L19 10H13Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
        </svg>
    )
}
